import { createContext } from "react";

const AdminDeshboardContext = createContext({});

export default AdminDeshboardContext;
